export const COOKIE_NAME = ".neko.ui_locales";

/**
 * Get the domain to be used in setCookie, beginning w a dot.
 */
export function getCookieDomain(): string {
  const domSplit = document.location.hostname.split(".");
  return "." + domSplit.slice(domSplit.length - 2).join(".");
}
